import type { Concept } from "../types";
import { PaperShell } from "./Shell";
import { PaperEmptyState, PaperPageHeader } from "./chrome";
import { PaperTaskRow } from "./TaskRow";
import { PaperTaskList } from "./TaskList";
import { PaperTaskDetail } from "./TaskDetail";
import { PaperBoard } from "./Board";
import { PaperTodayScreen } from "./Today";

export const paper: Concept = {
  id: "paper",
  name: "Paper",
  className: "concept-paper",
  defaultAppearance: "system",
  detailMode: "inline",
  rowHeight: 40,
  Shell: PaperShell,
  PageHeader: PaperPageHeader,
  EmptyState: PaperEmptyState,
  TaskRow: PaperTaskRow,
  TaskList: PaperTaskList,
  TaskDetail: PaperTaskDetail,
  Board: PaperBoard,
  TodayScreen: PaperTodayScreen,
};
